import { ErrorView } from "components/ErrorView/ErrorView";
import { GuestPage } from "components/GuestPage/GuestPage";
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

const InvitesModule = React.lazy(() => import("./InvitesModule"));
const ShareRegistrationLandingPage = React.lazy(
  () => import("./pages/ShareRegistrationPage/ShareRegistrationLandingPage"),
);

const DefaultPage: React.FC = () => {
  return <Navigate to="/auth/login" replace />;
};

export const InvitesModuleRoutes: RouteObject = {
  path: "/invites",
  element: <GuestPage El={InvitesModule} />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "demo",
      element: <GuestPage El={ShareRegistrationLandingPage} />,
    },
    {
      path: "",
      Component: DefaultPage,
    },
    {
      path: "*",
      Component: DefaultPage,
    },
  ],
};
